import React, { useState, useEffect } from "react";
import { Form, Input, Button, Icon, Checkbox } from 'antd';
import { InputNumber } from 'antd';
import { Switch } from 'antd';
import { MerchantService } from '../../../../services';
import { handleApiExceptions } from '../../../../app_methods';


let VirtualAccountSettingsForm = (props) => {
    const { form, virtualAccount } = props;
    const { getFieldDecorator } = form;
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            setIsLoading(true);
            MerchantService.update_settings(values).then((response) => {
                if (response.success) {
                    props.onSuccess();
                }
                else {
                    handleApiExceptions("Something went wrong.");
                }
                setIsLoading(false);
            }).catch((error) => {
                handleApiExceptions(error);
                setIsLoading(false);
            });
        });
    };
    
    useEffect(() => {
        form.setFieldsValue({ ...virtualAccount.settings });
    }, [virtualAccount])

    return (
        <Form onSubmit={onSubmit}>
            {getFieldDecorator("id", {
                initialValue: virtualAccount.id
            })(<Input hidden />)}

            <Form.Item label="Enable Low Balance Alert">
                {getFieldDecorator("enable_low_balance_alert", {
                            valuePropName: "checked",
                            })(<Switch />)}
            </Form.Item>

            <Form.Item  label="Threshold Amount">
                {getFieldDecorator("low_balance_alert_amount", {
                    rules: [
                        {
                            required: form.getFieldValue('enable_low_balance_alert'),
                            pattern: /^[1-9]\d*$/, message: "Please enter a valid Threshold Amount."
                        }
                    ]
                })(<InputNumber className="w-100" placeholder='Enter your Threshold Amount' disabled={!form.getFieldValue('enable_low_balance_alert')} />)}
            </Form.Item>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={isLoading}>Submit</Button>
            </div>
        </Form>
    )
};

VirtualAccountSettingsForm = Form.create()(VirtualAccountSettingsForm);

export { VirtualAccountSettingsForm };
